<template>
  <div>
    <h6 class="mt-3 mb-1">Укажите фильтры, для товаров в стратегии:</h6>
    <div class="row">
      <div class="col-sm-6">
        <label class="form-label">Фильтр по названию</label>
        <input type="text" class="form-control" v-model="localFilters.name">
      </div>
      <div class="col-sm-6">
        <label class="form-label">Фильтр по брендам</label>
        <InputText
          v-model="brandsInput"
          placeholder="Введите бренды через запятую"
          class="w-100"
          @input="handleBrandsInput"
        />
      </div>
      <div class="col-sm-6 mt-2">
        <label class="form-label">Фильтр по себестоимости</label>
        <div class="row">
          <div class="col-sm-6">
            <input type="text" class="form-control" v-model="localFilters.cost_min" placeholder="От">
          </div>
          <div class="col-sm-6">
            <input type="text" class="form-control col-sm-6" v-model="localFilters.cost_max" placeholder="До">
          </div>
        </div>
      </div>
    </div>
    <hr class="mt-4">
    <h6 class="mt-4">
      Предварительный список товаров
      <i class="ti ti-info-circle ti-sm ms-1" v-tooltip.bottom="'Список товаров будет обновлен при сохранении стратегии с учетом всех настроек и ограничений'"></i>
    </h6>
    <ProductsListSimple ref="ProductsList" :filters="debouncedFilters" v-show="hasFilters" />
    <div v-show="!hasFilters">
      <p>Фильтры не установлены</p>
    </div>
  </div>
</template>

<script>
import ProductsListSimple from "@/components/strategy/ProductsListSimple.vue";
import Tooltip from 'primevue/tooltip';
import InputText from 'primevue/inputtext';

export default {
  name: 'ProductsByFilters',
  components: { 
    ProductsListSimple,
    InputText
  },
  directives: {
    tooltip: Tooltip
  },
  data() {
    return {
      localFilters: {
        company: null,
        name: null,
        brand: null,
        brands: [],
        cost_min: null,
        cost_max: null,
        ...(this.filters || {})
      },
      debouncedFilters: { ...this.filters } || {},
      debounceTimeout: null,
      brandsInput: ''
    }
  },
  computed: {
    hasFilters() {
      if (!this.localFilters) return false;
      return Object.entries(this.localFilters).some(
        ([key, value]) => {
          if (['company', 'page', 'size'].includes(key)) return false;
          if (key === 'brands') return Array.isArray(value) && value.length > 0;
          return value !== null && value !== undefined && value !== '';
        }
      );
    }
  },
  props: {
    filters: {
      type: Object,
      required: false,
      default: () => ({
        company: null,
        name: null,
        brand: null,
        brands: [],
        cost_min: null,
        cost_max: null
      })
    }
  },
  methods: {
    handleBrandsInput(event) {
      const brands = event.target.value
        .split(',')
        .map(brand => brand.trim())
        .filter(brand => brand.length > 0);
      this.localFilters.brands = brands;
    },
    debounceFilters(newVal) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      
      this.debounceTimeout = setTimeout(() => {
        this.debouncedFilters = { ...newVal };
        this.$emit('update:filters', { ...newVal });
      }, 800);
    }
  },
  emits: ['update:filters'],
  watch: {
    filters: {
      handler(newVal) {
        console.log('filters', newVal)
        if (JSON.stringify(newVal) !== JSON.stringify(this.localFilters)) {
          this.localFilters = { ...newVal }
          if (newVal && newVal.brands) {
            this.brandsInput = newVal.brands?.join(', ') || ''
          } else {
            this.brandsInput = ''
          }
          this.debouncedFilters = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    },
    localFilters: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.filters)) {
          this.debounceFilters(newVal);
        }
      },
      deep: true
    }
  }
}
</script>